<template>
  <div
    v-click-outside="onClickOutside"
    class="filter-by-condition"
    :class="{ 'filter-by-condition--open': isOpen }"
  >
    <button
      class="filter-by-condition__button button"
      @click.stop="handleClick"
    >
      {{ buttonText }}

      <icon-component
        :name="buttonIcon"
        title="caret icon"
        class="filter-by-condition__icon icon--small"
      />
    </button>
    <div class="filter-by-condition__dropdown">
      <condition-select
        ref="conditionSelect"
        :click-handler-for-options="onConditionSelect"
        :collapsible="false"
      />
    </div>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside';
import ConditionSelect from '@/components/Disorder/ConditionSelect.vue';
import { DISORDER_DETAIL } from '@/graphql/queries/disorder-queries';

export default {
  name: 'FillterByCondition',
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    ConditionSelect,
  },
  data() {
    return {
      condition: null,
      isOpen: false,
    };
  },
  computed: {
    buttonText() {
      return this.condition?.name || 'Filter by';
    },
    buttonIcon() {
      return this.condition ? 'x' : 'caret';
    },
  },
  methods: {
    onClickOutside() {
      this.isOpen = false;
    },
    handleClick() {
      if (this.condition) {
        this.condition = null;
        this.$emit('conditionCleared', null);
        return;
      }

      this.isOpen = !this.isOpen;
      if (this.isOpen) this.$refs.conditionSelect.focusInput();
    },
    onConditionSelect(event, condition) {
      this.condition = condition;
      this.$emit('conditionSelected', condition);
      this.isOpen = false;
    },
  },
  apollo: {
    disorderDetail: {
      skip() { return !this.$route.query.con; },
      query: DISORDER_DETAIL,
      variables() {
        return {
          slug: this.$route.query.con,
          ignore404: true,
        };
      },
      result({ data }) {
        if (data?.disorderDetail) {
          this.condition = {
            name: data.disorderDetail.name,
            id: data.disorderDetail.id,
            slug: data.disorderDetail.slug,
          };
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
  @import '@/stylesheets/components/_filter-by-condition';
</style>
